import type { OrganizationLogoProps } from "./organization-logo.type";

import { useTranslation } from "react-i18next";

import ModelIcon from "@/modules/model-icon";

export const OrganizationLogo = ({
  organization,
  iconFallback,
}: OrganizationLogoProps) => {
  const { t } = useTranslation();
  const logo = organization.logo_document;
  const alt = t("global:logoAlt", { name: organization.name });

  if (logo) {
    return <img src={logo.url} alt={alt} className="organization-logo" />;
  }

  if (iconFallback) {
    return (
      <ModelIcon model="organization" className="organization-logo-icon" />
    );
  }

  return null;
};
